module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('v-col', [_c('v-card', [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Influencer Account",
      "placeholder": "username or url",
      "outlined": "",
      "required": ""
    },
    model: {
      value: (_vm.userAccount),
      callback: function($$v) {
        _vm.userAccount = $$v
      },
      expression: "userAccount"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "solo": "",
      "items": _vm.platformList,
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.selectedPlatform),
      callback: function($$v) {
        _vm.selectedPlatform = $$v
      },
      expression: "selectedPlatform"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download(PDF)")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2caf38c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/InfluencerSocialData/index.vue
// module id = 2273
// module chunks = 0